<template>
  <div class="container">
    <div class="section testimonials">
      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Wasze zdanie jest najważniejsze</h5>
        <h2 class="title">Opinie naszych klientów</h2>
        <p class="subtitle">
          Jesteśmy wdzięczni za każdą ocenę tą dobrą i tą mniej przychylną. To przede wszystkim
          dzięki
          słuchaniu Was, naszych klientów, jesteśmy jedną z najbardziej docenianych pizzerii w
          Ząbkach.
        </p>
      </div>

      <Slick :options="settings" ref="testimonialSlick" class="ct-testimonials-slider">

        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img :src="getImagePath('assets/images/empty_avatar.jpg')" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Pizza bardzo smaczna! Dosyć szybki czas oczekiwania i bardzo miła obsługa.
                Polecam serdecznie pizze (w lokalu) w restauracji jak i na wynos.
              </p>
              <h5>Aleksandra</h5>
              <span>Źródło: Facebook</span>
            </div>
          </div>
        </div>

        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img :src="getImagePath('assets/images/empty_avatar.jpg')" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>Zdecydowanie królowa pizzerii w Ząbkach a i mało gdzie można zjeść równie
                smaczną
                pizze.
                Sosy mega, ciasto cienkie i ekstra wypieczone, dodatki pyszne. 6+
              </p>
              <h5>Małgorzata</h5>
              <span>Źródło: Facebook</span>
            </div>
          </div>
        </div>

        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img :src="getImagePath('assets/images/empty_avatar.jpg')" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Po prostu mega! Smak, cena, dostawa nic dodać nic ująć
              </p>
              <h5>Wojtek</h5>
              <span>Źródło: Google</span>
            </div>
          </div>
        </div>

        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img :src="getImagePath('assets/images/empty_avatar.jpg')" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Świetne miejsce z przyjemnym wystrojem. [...] Co najważniejsze, bardzo dobra pizza z dużą ilością
                składników w przystępnej cenie. Polecam i z pewnością wrócę tu.
              </p>
              <h5>Katarzyna</h5>
              <span>Źródło: Google</span>
            </div>
          </div>
        </div>

        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img :src="getImagePath('assets/images/empty_avatar.jpg')" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Pizza z Milano jest The best. Pyszna gorąca i na czas a nawet szybciej
              </p>
              <h5>Monika</h5>
              <span>Źródło: Facebook</span>
            </div>
          </div>
        </div>
      </Slick>

      <div class="ct-arrows centered-arrows with-margin">
        <i @click="prev" class="fas fa-arrow-left slider-prev slick-arrow"></i>
        <i @click="next" class="fas fa-arrow-right slider-next slick-arrow"></i>
      </div>
    </div>
  </div>
</template>
<script>
import Slick from 'vue-slick'
import '../../assets/css/plugins/slick.css'
import '../../assets/css/plugins/slick-theme.css'
import imageMixin from "@/mixins/imageMixin";

export default {
  name: 'testimonials',
  mixins: [imageMixin],
  components: {Slick},
  data() {
    return {
      settings: {
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      }
    }
  },
  methods: {
    next() {
      this.$refs.testimonialSlick.next();
    },
    prev() {
      this.$refs.testimonialSlick.prev();
    },
  },
}
</script>